import { render, staticRenderFns } from "./crumb.vue?vue&type=template&id=640a55b4"
import script from "./crumb.vue?vue&type=script&lang=js"
export * from "./crumb.vue?vue&type=script&lang=js"
import style0 from "./crumb.vue?vue&type=style&index=0&id=640a55b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports